import { useFlags } from 'domains/launchdarkly/hooks'
import { isTabInExperience } from 'domains/launchdarkly/portalExperience'
import { string } from 'prop-types'
import React from 'react'
import ProtectedRoute from '../ProtectedRoute'

/**
 * Gates a patient tab's route on the viewer's portal experience preset.
 *
 * `Root` withholds its `<Outlet />` until `ldClient.identify()` resolves, so flags
 * are populated before any patient route mounts and no loading state is needed
 * here. A missing flag value resolves to the default experience.
 */
const ProtectedByPortalExperience = ({ redirectPath, tabKey }) => {
  const { portalExperience } = useFlags() || {}

  return (
    <ProtectedRoute
      isAllowed={isTabInExperience(portalExperience, tabKey)}
      redirectPath={redirectPath}
    />
  )
}

ProtectedByPortalExperience.propTypes = {
  redirectPath: string.isRequired,
  tabKey: string.isRequired,
}

ProtectedByPortalExperience.defaultProps = {}

export default ProtectedByPortalExperience
